export const async_amazon_review = {
  asyncType: 'amazon-review',
  hostedScraperType:  'async_amazon_review',
  publicHostedScraperAPIType:  'amazon_review',
  inputKey: 'asin',
  inputsKey: 'asins',
  inputJsonSchema: { type: 'string', pattern: '^[a-zA-Z0-9]{10}$' },
  asyncEndpoint: '/structured/amazon/review',
  apiEndpoint: '/structured/amazon/review',
  apiCostEndpoint: '/account/amazonreviewcost',
  propertiesJsonSchemaPart: {
    output_format: { type: 'string', enum: [ 'csv', 'json' ] },
    tld: { type: 'string' },
    country_code: { type: 'string' },
    ref: { type: 'string' },
    filter_by_star: { type: 'string' },
    reviewer_type: { type: 'string' },
    page_number: { type: 'string', pattern: '[0-9]+' },
    sort_by: { type: 'string' }
  }
};
